import { render } from "./App.vue?vue&type=template&id=a44c8698"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a44c8698&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__